import { ReactNode, useMemo, useRef } from 'react';
import { AppScreenContext } from './AppScreenContext';

type Props = {
  className?: string;
  children?: ReactNode;
  isFullScreen?: boolean;
};

export const AppScreen = ({ children, className = '', isFullScreen }: Props) => {
  const headerRef = useRef<HTMLDivElement>(null);

  const contextValue = useMemo(() => ({ headerRef }), []);

  return (
    <AppScreenContext.Provider value={contextValue}>
      <div className={`app-screen ${className} ${isFullScreen ? 'full-screen' : ''}`}>
        <div ref={headerRef} />
        {children}
      </div>
    </AppScreenContext.Provider>
  );
};
